function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { withi18n } from "../../../../../customer/components";
import ExpertDialogueWrapper from "../expert-dialogue-wrapper/ExpertDialogueWrapper";
import ExpertDialogueBody from "../expert-dialogue-body/ExpertDialogueBody";
import ExpertTimePosted from "../expert-time-posted/ExpertTimePosted";
import ExpertRating from "../expert-rating/ExpertRating";
const ExpertDialogue = ({
  t,
  classes,
  dialogue,
  ...rest
}) => {
  const {
    author,
    body,
    created,
    userId,
    userType
  } = dialogue;
  const {
    conversationState,
    expertAuthors
  } = rest.message;
  const showExpertRating = conversationState.showExpertRating;
  const expertInfo = expertAuthors[userId];
  return /*#__PURE__*/React.createElement(ExpertDialogueWrapper, _extends({
    shouldAnimate: false,
    dialogue: dialogue
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement(ExpertDialogueBody, {
    body: body
  }, /*#__PURE__*/React.createElement(ExpertRating, {
    expertInfo: expertInfo,
    t: t,
    classes: classes,
    showExpertRating: showExpertRating,
    author: author,
    userType: userType
  })), /*#__PURE__*/React.createElement(ExpertTimePosted, {
    dialogue: dialogue,
    time: created
  })));
};
export default withi18n(ExpertDialogue);
ExpertDialogue.propTypes = {
  dialogue: PropTypes.object.isRequired,
  classes: PropTypes.object,
  t: PropTypes.func.isRequired
};